import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Typography, Hidden} from "@material-ui/core";
import {TooltipCustom} from "../../component/common/TooltipCustom";

const useStyles = makeStyles(theme => ({
    root: {
        color: '#fff',
        backgroundColor: '#545454',
        padding: '50px 10%',
        [theme.breakpoints.only('xs')]: {
            padding: '50px 10px',
            textAlign: 'center',
            paddingBottom: 20
        },
    },
    logo: {
        "&:hover": {cursor: 'pointer'},
        [theme.breakpoints.only('xs')]: {
            width: 300,
        },
    },
    rectangleContainer: {
        display: 'flex',
        alignItems: 'center',
        [theme.breakpoints.only('xs')]: {
            justifyContent: 'center'
        },
    },
    rectangle: {
        flexGrow: 1,
        border: '1px solid #FFFFFF',
        marginRight: 10,
        [theme.breakpoints.only('xs')]: {
            margin: '20px 0px',
        },
    },
    icon: {
        margin: 10,
        "&:hover": {cursor: 'pointer'},
    },
    linkContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        textAlign: 'center'
    },
    link: {
        textDecoration: 'underline',
        "&:hover": {cursor: 'pointer'},
    },
    linkNotClickable: {
        textDecoration: 'underline',
    },
}));

function Footer({scrollTo, onClickOpenDialog}) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <img src={'/image/footer/logo.png'} alt={"Logo entreprise"} className={classes.logo} onClick={() => {
                scrollTo("/")
            }}/>
            <Hidden only={["xs"]}>
                <div className={classes.rectangleContainer}>
                    <div className={classes.rectangle}/>
                    <a href="tel:04 48 20 15 10">
                        <TooltipCustom title="04 48 20 15 10" interactive>
                            <img src="/image/footer/IconeAppel.png" alt="Icon cliquable pour appeler"
                                 className={classes.icon}/>
                        </TooltipCustom>
                    </a>
                    <a href="mailto:soc@cyklad.fr">
                    <TooltipCustom title="soc@cyklad.fr" interactive>
                        <img src="/image/footer/IconeMail.png" alt="Icon cliquable pour envoyer un mail"
                             className={classes.icon}/>
                    </TooltipCustom>
                    </a>
                </div>
            </Hidden>
            <Hidden only={["sm", "md", "lg", "xl"]}>
                <div className={classes.rectangle}/>
                <div className={classes.rectangleContainer}>
                    <a href="tel:04 48 20 15 10">
                        <TooltipCustom title="04 48 20 15 10" interactive>
                            <img src="/image/footer/IconeAppel.png" alt="Icon cliquable pour appeler"
                                 className={classes.icon}/>
                        </TooltipCustom>
                    </a>
                    <a href="mailto:soc@cyklad.fr">
                        <TooltipCustom title="soc@cyklad.fr" interactive>
                            <img src="/image/footer/IconeMail.png" alt="Icon cliquable pour envoyer un mail"
                                 className={classes.icon}/>
                        </TooltipCustom>
                    </a>
                </div>
                <br/>
            </Hidden>
            <Typography component={'p'} gutterBottom>
                Bureau 2 67 Rue Joe Dassin<br/>34080 Montpellier
            </Typography>
            <br/>
            <Hidden only={["xs"]}>
                <div className={classes.linkContainer}>
                    <Typography component={'p'} className={classes.link}
                                onClick={() => onClickOpenDialog('/mention-legale')}>
                        Mentions Légales
                    </Typography>
                    <Typography component={'p'} className={classes.link} onClick={() => onClickOpenDialog('/cookies')}>
                        Cookies
                    </Typography>
                    <Typography component={'p'} className={classes.link}
                                onClick={() => onClickOpenDialog('/conditions-utilisation')}>
                        Conditions d'Utilisation
                    </Typography>
                    <Typography component={'p'} className={classes.link}>
                        Accesibilité
                    </Typography>
                    <Typography component={'p'} className={classes.link}
                                onClick={() => onClickOpenDialog('/plan-du-site')}>
                        Plan du Site
                    </Typography>
                    <Typography component={'p'} className={classes.linkNotClickable}>
                        © 2021 Cyklad. Tout droits réservés
                    </Typography>
                </div>
            </Hidden>
            <Hidden only={["sm", "md", "lg", "xl"]}>
                <Typography component={'p'} className={classes.link}
                            onClick={() => onClickOpenDialog('/mention-legale')}>
                    Mentions Légales
                </Typography>
                <Typography component={'p'} className={classes.link} onClick={() => onClickOpenDialog('/cookies')}>
                    Cookies
                </Typography>
                <Typography component={'p'} className={classes.link}
                            onClick={() => onClickOpenDialog('/conditions-utilisation')}>
                    Conditions d'Utilisation
                </Typography>
                <Typography component={'p'} className={classes.link}>
                    Accesibilité
                </Typography>
                <Typography component={'p'} className={classes.link} onClick={() => onClickOpenDialog('/plan-du-site')}>
                    Plan du Site
                </Typography>
                <Typography component={'p'} className={classes.linkNotClickable}>
                    © 2021 Cyklad. Tout droits réservés
                </Typography>
            </Hidden>
        </div>
    )
}

export default Footer
